import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { deleteWorkOrder } from '#/graphql/mutations';
import { GET_WORK_ORDER_PROPS_COUNTS } from './useWorkOrderPropsCountsQuery';

const q = gql(deleteWorkOrder);

const useWorkOrderDelete = () => {
  const [mutation, result] = useMutation(q);

  const deleteWorkOrder = useCallback(
    (workOrderId: string) => {
      return mutation({
        variables: {
          id: workOrderId,
        },
        refetchQueries: [{ query: GET_WORK_ORDER_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });
    },
    [mutation],
  );

  return { deleteWorkOrder, result };
};

export default useWorkOrderDelete;
